import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);

  const sessionReady = useSelector((state) => state.aplicationConfig.userConfig.sessionReady);

  if (!sessionReady) return <p role="status">Comprobando tu sesión…</p>;

  if (logged) {
    return children;
  } else {
    return <Navigate to={`/login?returnTo=${encodeURIComponent(location.pathname)}&back=%2F`} replace />;
  }
};
